var exports = {
  "wQ": "SudoVerificationModal.module__passkeyVerifying___MTBOZF",
  "hU": "SudoVerificationModal.module__unavailable___MTBOZF",
  "TJ": "SudoVerificationModal.module__unavailableTitle___MTBOZF",
  "$r": "SudoVerificationModal.module__unavailableBody___MTBOZF",
  "zc": "SudoVerificationModal.module__formError___MTBOZF",
  "kK": "SudoVerificationModal.module__passkeyHint___MTBOZF",
};

module.exports = exports;
